import {
    Row,
    Col
} from "reactstrap";
// import { useNavigate } from "react-router-dom";

import { Spinner } from "react-bootstrap";

import { addChangePassword } from "../services/changePasswordServices";

// import utils from "../../../utils/utils";
import FullLayout from '../layouts/FullLayout';

// import Pagination from "../../../components/Pagination";
import Toast from 'react-bootstrap/Toast';
import { RoleContext, AlertContext } from "../utils/contexts/RoleContext";
import { useState, useEffect, useContext } from "react";
import Form from 'react-bootstrap/Form';
import InputGroup from 'react-bootstrap/InputGroup';
// import DeleteModal from "../../../components/DeleteModal";
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';


export default function Settings() {

    const [currentPassword, setCurrentPassword] = useState('')
    const [newPassword, setNewPassword] = useState('')
    const [confirmPassword, setConfirmPassword] = useState('')

    const [currentPasswordError, setCurrentPasswordError] = useState('')
    const [newPasswordError, setNewPasswordError] = useState('')
    const [confirmPasswordError, setConfirmPasswordError] = useState('')


    // const toast: any = useContext(ToastContext);
    const [show, setShow] = useState(false);
    const [successValue, setSuccessValue] = useState("");
    const [message, setMessage] = useState("")


    const toast = useContext(AlertContext);

    const handlecurrentPassword = (event) => {
        setCurrentPassword(event.target.value)
        if (currentPasswordError !== "") {
            setCurrentPasswordError("")
        }
    }
    const handleChangenewPassword = (event) => {
        setNewPassword(event.target.value)
        if (newPasswordError !== "") {
            setNewPasswordError("")

        }
    }
    const handleChangeconfirmPassword = (event) => {
        setConfirmPassword(event.target.value)
        if (confirmPasswordError !== "") {
            setConfirmPasswordError("")
        }
    }
    const handleSubmit = async (event) => {
        event.preventDefault()
        if (currentPassword === '') {
            setCurrentPasswordError('Current Password Required*')
            return false
        }
        if (newPassword === '') {
            setNewPasswordError('New Password Required*')
            return false
        }
        if (confirmPassword === '') {
            setConfirmPasswordError('Confirm Password Required*')
            return false
        }

        try {

            const response = await addChangePassword(currentPassword, newPassword, confirmPassword);
            const responseData = response?.data;
            console.log("response", responseData)
            let theme = "success";

            if (response?.status === 200) {
                // navigate(`/${role}/categories`)
                console.log("response", response)
            } else {
                console.log("error", response)
                theme = "danger"
            }
            // setLoading(false);
            window.scrollTo(0, 0);
            toast.setToast(responseData?.message, theme);
            console.log("responseData?.data", responseData?.data)
        } catch (error) {
            // setLoading(false);
            console.error("Error:", error);
        }
    }



    return (
        <FullLayout
        >

            <Row>
                <div className="panel_top_section ">
                    <h1>Change Password</h1>


                </div>
                <Col>
                    <Form
                        onSubmit={handleSubmit}
                    >

                        <Form.Group className="mb-3">
                            <Form.Label htmlFor="basic-url" className="mt-3">Current Password</Form.Label>
                            <InputGroup className="mb-3">

                                <Form.Control type="text" className='' onChange={handlecurrentPassword} value={currentPassword} />
                            </InputGroup>
                            {currentPasswordError ? <span className="text-danger">{currentPasswordError}</span> : ""}
                        </Form.Group>

                        <Form.Group className="mb-3">
                            <Form.Label htmlFor="basic-url">New Password</Form.Label>
                            <InputGroup className="mb-3">

                                <Form.Control type="text" onChange={handleChangenewPassword} value={newPassword} />
                            </InputGroup>
                            {newPasswordError ? <span className="text-danger">{newPasswordError}</span> : ""}


                        </Form.Group>


                        <Form.Group className="mb-3">
                            <Form.Label htmlFor="basic-url">Confirm Password</Form.Label>
                            <InputGroup className="mb-3">

                                <Form.Control type="text" className='' onChange={handleChangeconfirmPassword} value={confirmPassword} />

                            </InputGroup>
                            {confirmPasswordError ? <span className="text-danger">{confirmPasswordError}</span> : ""}

                        </Form.Group>

                        <button
                            className="btn_gradian ms-3 mt-3"
                            type="submit"
                        // onClick={handleEdit}
                        >
                            Update
                        </button>

                    </Form>
                </Col>
                {show &&
                    <Toast className={successValue === "success" ? "float-start end-0 position-absolute show bg-success z-3" : "float-start end-0 position-absolute show bg-danger z-3"} style={{ top: "0px" }}>
                        <Toast.Header className={`show ${successValue === "success" ? "bg-success" : "bg-danger"}`}>
                            <strong className="me-auto text-white">Success Message</strong>
                        </Toast.Header>
                        <div aria-live="polite" aria-atomic="true" className="d-flex justify-content-center align-items-center w-100 mb-10 text-white bg-transparent">
                            <div className="fade toast show  bg-transparent" role="alert" aria-live="assertive" aria-atomic="true">
                                <div className="fade toast show bg-transparent p-4 text-white">
                                    {message}
                                </div>
                            </div>
                        </div>
                    </Toast>
                }
            </Row >

        </FullLayout>
    )
}